import cabieLogo from '../images/eori-white-logo.svg';
import cabieFavicon from '../images/cabie-favicon.png';
import dtwLogo from '../images/dtw-logo.jpg';
import dtwFavicon from '../images/dtw-favicon.png';
import FloraLincLogo from '../images/fl.png';
import FloraLincFavicon from '../images/fl2.png';
import tekFreightLogo from '../images/tek-blue-logo.svg';
import tekFreightFavicon from '../images/tek_fav.png';
import zelirLogo from '../images/zelir-logo.png';
import zelirFavicon from '../images/zelir-logo1.png';
import lglLogo from '../images/lgl-logo.png';
import chillChainLogo from '../images/Chill-Chain_Logo.png';
import chillChainFavicon from '../images/cc-favicon.gif';
import capitalTransportLogo from '../images/ctlogo.png';
import theunisseExpeditieLogo from '../images/dl-logo.jpg';
import paulPonsonbyLogo from '../images/ponsonby.png';
import alcalineLogo from '../images/alcaline.png';
import c3plLogo from '../images/C-3PLLogo.png';
import c3plFavicon from '../images/c3pl-favicon.jpg';
import oaklandLogo from '../images/OaklandLogo.png';
import oaklandFavicon from '../images/oakfav.png';
import pay360Logo from '../images/360-logo.png';
import pay360Favicon from '../images/360-favicon.png';
import completeFreightLogo from '../images/C-FC-Logo.png';
import completeFreightFavicon from '../images/C-FC-Favicon.png';
import manuelSamperLogo from '../images/manuelSamperLogo.png';
import manuelSamperFavicon from '../images/manuelSamperFavicon.png';
import matuskaLogo from '../images/matuska-logo.jpg';
import matuskaFavicon from '../images/matuska-favicon.ico';
import { wlpContext } from '../store/wlpStore';
import { useContext, useEffect } from 'react';
import { cabieTheme } from '../styles/themes/cabieTheme';

const wlpData = {
  'floralinc.cabie.uk': {
    isWLP: true,
    wlpName: 'FloraLinc',
    logo: FloraLincLogo,
    favicon: FloraLincFavicon,
    title: 'FloraLinc',
  },
  'tekfreight.cabie.uk': {
    isWLP: true,
    wlpName: 'TEK Freight',
    logo: tekFreightLogo,
    favicon: tekFreightFavicon,
    title: 'Temperature controlled transport | TEK Freight',
    showAndFormatMainPageText: { left: '4rem', top: '45%' },
    navbarFontColour: '#0078AB',
  },
  'zelir.cabie.uk': {
    isWLP: true,
    wlpName: 'ZELIR LOGISTICS',
    logo: zelirLogo,
    favicon: zelirFavicon,
    title: 'ZELIR LOGISTICS',
  },
  // zelir demo environment
  'zelir.eoricustomtech.co.uk': {
    isWLP: true,
    wlpName: 'ZELIR LOGISTICS',
    logo: zelirLogo,
    favicon: zelirFavicon,
    title: 'ZELIR LOGISTICS',
  },
  'lglworldwide.cabie.uk': {
    isWLP: true,
    wlpName: 'LGL WorldWide Logistics',
    logo: lglLogo,
    favicon: lglLogo,
    navbarFontColour: '#000',
    title: 'International Air Freight Services | LGL WorldWide Logistics',
  },
  'chillchain.cabie.uk': {
    isWLP: true,
    wlpName: 'Chill-Chain',
    logo: chillChainLogo,
    favicon: chillChainFavicon,
    title: 'Chill-Chain',
  },
  'capitaltransport.cabie.uk': {
    isWLP: true,
    wlpName: 'Capital Transport',
    logo: capitalTransportLogo,
    favicon: capitalTransportLogo,
    title: 'Captial Transport',
  },
  'theunisse-expeditie.cabie.uk': {
    isWLP: true,
    wlpName: 'Theunisse Expeditie',
    logo: theunisseExpeditieLogo,
    favicon: theunisseExpeditieLogo,
    navbarFontColour: '#000',
    title: 'Theunisse Expeditie',
  },
  'ponsonby.cabie.uk': {
    isWLP: true,
    wlpName: 'Paul Ponsonby',
    logo: paulPonsonbyLogo,
    favicon: paulPonsonbyLogo,
    title: 'Paul Ponsonby',
  },
  'alcaline.cabie.uk': {
    isWLP: true,
    wlpName: 'Alcaline',
    logo: alcalineLogo,
    favicon: alcalineLogo,
    navbarFontColour: '#000',
    title: 'Alcaline',
  },
  'complete3pl.cabie.uk': {
    isWLP: true,
    wlpName: 'C-3PL',
    logo: c3plLogo,
    favicon: c3plFavicon,
    title: 'C-3PL',
  },
  'oakland-international.cabie.uk': {
    isWLP: true,
    wlpName: 'Oakland International',
    logo: oaklandLogo,
    favicon: oaklandFavicon,
    navbarFontColour: '#000',
    title: 'Oakland International',
  },
  '360pays.cabie.uk': {
    isWLP: true,
    wlpName: '360PAY',
    logo: pay360Logo,
    favicon: pay360Favicon,
    navbarFontColour: '#000',
    title: '360PAY',
  },
  'completefreight-customs.cabie.uk': {
    isWLP: true,
    wlpName: 'Complete Freight & Customs',
    logo: completeFreightLogo,
    favicon: completeFreightFavicon,
    navbarFontColour: '#000',
    title: 'Complete Freight & Customs',
  },
  'dtwlogistics.cabie.uk': {
    isWLP: true,
    wlpName: 'DTW Logistics',
    logo: dtwLogo,
    navbarFontColour: '#000',
    favicon: dtwFavicon,
    title: 'DTW Logistics',
  },
  'manuelsamper.cabie.uk': {
    isWLP: true,
    wlpName: 'Manuel Samper',
    logo: manuelSamperLogo,
    navbarFontColour: '#333F61',
    favicon: manuelSamperFavicon,
    title: 'Manuel Samper',
  },
  'matuska.cabie.uk': {
    isWLP: true,
    wlpName: 'Matuska',
    logo: matuskaLogo,
    favicon: matuskaFavicon,
    title: 'MATUŠKA Transport und Spedition GmbH',
  },
};

const cabieData = {
  showWebinars: true,
};

const CABIE_DESCRIPTION =
  'Streamline your customs process with CABIE. Experience faster imports, reduced paperwork, and lower costs, all with expert support available 24/7.';

const defaultData = {
  isWLP: false,
  wlpName: '',
  logo: cabieLogo,
  showWebinars: false,
  navbarFontColour: '#fff',
  showAndFormatMainPageText: false,
  favicon: cabieFavicon,
  title: 'CABIE',
  description: CABIE_DESCRIPTION,
  theme: cabieTheme,
};

const getWlpData = (url) => {
  let selectedWlpData = wlpData[url] || cabieData;

  // Override for dev and UAT to mimic a different provider
  if (url === 'wdev.eoricustomtech.co.uk' || url === 'uat-wlp.eoricustomtech.co.uk') {
    selectedWlpData = wlpData['tekfreight.cabie.uk'];
  }

  return { ...defaultData, ...selectedWlpData };
};

export const getWlpOptions = () => {
  const partnersData = Object.keys(wlpData).map((wlp) => {
    //Zelir demo environment needs a different name to regular zelir
    if (wlp === 'zelir.eoricustomtech.co.uk') {
      return { name: 'zelir demo', url: wlp };
    }

    return { name: wlp.split('.')[0], url: wlp };
  });

  return [
    { name: 'CABIE', url: 'CABIE' },
    { name: 'wdev', url: 'wdev.eoricustomtech.co.uk' },
    { name: 'uat-wlp', url: 'uat-wlp.eoricustomtech.co.uk' },
    ...partnersData,
  ];
};

export const useWlpData = (url) => {
  const {
    setIsWLP,
    setWlpName,
    setLogo,
    setNavbarFontColour,
    setShowMainPageText,
    setShowWebinars,
    muiTheme,
    setMuiTheme,
  } = useContext(wlpContext);

  useEffect(() => {
    const {
      isWLP,
      wlpName,
      logo,
      showWebinars,
      navbarFontColour,
      showAndFormatMainPageText,
      favicon,
      title,
      description,
      theme,
    } = getWlpData(url);

    document.title = title;
    document.body.setAttribute('data-wlp-name', wlpName);
    document.getElementById('favicon').setAttribute('href', favicon);
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription && description) {
      metaDescription.setAttribute('content', description);
    }

    const robotsMeta = document.getElementById('robotsMeta');
    // prevent WLPs from appearing in google searches
    if (isWLP) {
      if (robotsMeta) {
        // prevent adding duplicate elements
        robotsMeta.setAttribute('content', 'noindex');
      } else {
        const noIndex = document.createElement('meta');
        noIndex.setAttribute('id', 'robotsMeta');
        noIndex.setAttribute('name', 'robots');
        noIndex.setAttribute('content', 'noindex');
        document.head.appendChild(noIndex);
      }
    } else if (robotsMeta) {
      robotsMeta.remove();
    }

    setWlpName(wlpName);
    setIsWLP(isWLP);
    setShowWebinars(showWebinars);
    setLogo(logo);
    setNavbarFontColour(navbarFontColour);
    setShowMainPageText(showAndFormatMainPageText);
    setMuiTheme(theme);
  }, [url, setIsWLP, setLogo, setNavbarFontColour, setShowMainPageText, setShowWebinars, setWlpName]);

  return { muiTheme };
};
